import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const CacheContext = createContext();

export const useCacheStore = () => {
  const context = useContext(CacheContext);
  if (!context) {
    throw new Error('useCacheStore must be used within a CacheProvider');
  }
  return context;
};

export const CacheProvider = ({ children }) => {
  const [recentProfiles, setRecentProfiles] = useState(() => {
    const saved = localStorage.getItem('recentProfiles');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('recentProfiles', JSON.stringify(recentProfiles));
  }, [recentProfiles]);

  const addToCache = (profile) => {
    setRecentProfiles(prev => {
      const filtered = prev.filter(p => p.CAS_number !== profile.CAS_number);
      return [profile, ...filtered].slice(0, 10); // Keep only 10 recent profiles
    });
  };

  const getFromCache = (casNumber) => {
    return recentProfiles.find(profile => profile.CAS_number === casNumber);
  };

  const fetchChemicalDetails = async (casNumber) => {
    try {
      const cached = getFromCache(casNumber);
      if (cached) {
        return cached;
      }

      const response = await axios.get(`/api/chemical/${casNumber}`);
      const profile = response.data;
      addToCache(profile);
      return profile;
    } catch (error) {
      console.error('Error fetching chemical details:', error);
      throw error;
    }
  };

  const value = {
    recentProfiles,
    addToCache,
    getFromCache,
    fetchChemicalDetails
  };

  return (
    <CacheContext.Provider value={value}>
      {children}
    </CacheContext.Provider>
  );
};
